<div
  *ngIf="printProduct?.product?.folderName"
  class="settings-config-title flex items-center gap-2 px-2 py-2"
  (elementResize)="settingsConfigTitleHeight.set($event)"
  #settingsConfigTitle
>
  <span class="settings-config-title-text">Configurando {{ printProduct.product.folderName }}</span>
  <span class="close-icon" (click)="closeSettings()">
    <img src="assets/icon/cross.svg" alt="Cerrar" />
  </span>
</div>

<div
  class="settings_selectorButtonContainer none flex flex-row"
  (elementResize)="settingsSelectorButtonsHeight.set($event)"
  #settingsSelectorButtons
>
  <div class="settings_selectorButtonInnerContainer w-100 flex flex-row">
    <div
      class="selector_mark"
      [ngClass]="settingSelector === 'general' ? 'selected-general' : 'selected-finishing'"
    ></div>
    <button
      class="settings_selectorButton flex-1"
      (click)="setSettingSelector('general')"
      [ngClass]="{ selected: settingSelector === 'general', 'selected-general': settingSelector === 'general' }"
    >
      <div class="flex flex-row items-center justify-center gap-2">
        <ion-icon icon="assets/icon/settings_tab_selector.svg"></ion-icon>
        <ion-label class="">Impresión</ion-label>
      </div>
    </button>
    <button
      class="settings_selectorButton flex-1"
      (click)="setSettingSelector('finishing')"
      [ngClass]="{ selected: settingSelector === 'finishing', 'selected-finishing': settingSelector === 'finishing' }"
    >
      <div class="flex flex-row items-center justify-center gap-1">
        <ion-icon icon="assets/icon/finishing_tab_selector.svg"></ion-icon>
        <ion-label class="">Acabado</ion-label>
      </div>
    </button>
  </div>
</div>

<div class="settings_content flex h-full flex-row" [class.disabled]="isLoading">
  <app-general-settings-section
    *ngIf="settingSelector === 'general'"
    [settings]="settings"
    [printProduct]="printProduct"
    (settingSelectedEvent)="settingSelectedOption($event)"
    (goToFinishingEvent)="setSettingSelector('finishing')"
    (closeSettingsEvent)="closeSettings()"
    [isMobile]="isMobile()"
    [settingsSectionHeight]="settingsSectionHeight()"
    [settingsConfigTitleHeight]="settingsConfigTitleHeight()"
    [settingsSelectorButtonsHeight]="settingsSelectorButtonsHeight()"
  ></app-general-settings-section>
  <app-finishing-settings-section
    *ngIf="settingSelector === 'finishing'"
    [settings]="settings"
    (settingSelectedEvent)="settingSelectedOption($event)"
    [printProduct]="printProduct"
    (goToGeneralSettingsEvent)="setSettingSelector('general')"
    (closeSettingsEvent)="closeSettings()"
    [isMobile]="isMobile()"
    [settingsSectionHeight]="settingsSectionHeight()"
    [settingsConfigTitleHeight]="settingsConfigTitleHeight()"
    [settingsSelectorButtonsHeight]="settingsSelectorButtonsHeight()"
  ></app-finishing-settings-section>
</div>
<div class="settings_hideButton" (click)="changeMenuCollapsed()">
  <div>
    <ion-icon id="settings_hideButton_shape" icon="assets/icon/settingsMenuCollapseShape.svg"></ion-icon>
    <ion-icon
      id="settings_hideButton_arrow"
      icon="assets/icon/flechaIzquierda.svg"
      [ngClass]="{ collapsed: menuCollapsed }"
    ></ion-icon>
  </div>
</div>
